import { MDBRow, MDBCol, MDBCarousel, MDBCarouselItem } from "mdb-react-ui-kit"
import HomeBanner1 from "../asset/images/BGImages/Home.jpg";
import HomeBanner2 from "../asset/images/BGImages/2.jpg";
import HomeBanner3 from "../asset/images/BGImages/loan_bg.jpg";

export default function Banner(props) {

    return (
        <div className="w-100 position-relative mb-2" style={{ height: "85%" }}>
            <MDBCarousel interval={2500} className="h-100 w-100" fade>
                <MDBCarouselItem itemId={1} className="h-100 w-100">
                    <div className="h-100 w-100">
                        <img src={HomeBanner1} className='h-100 w-100' alt='...' id="banner" />
                    </div>
                </MDBCarouselItem>
                <MDBCarouselItem itemId={2}>
                    <div className="h-100 w-100">
                        <img src={HomeBanner2} className='h-100 w-100' alt='...' id="banner" />
                    </div>
                </MDBCarouselItem>
                <MDBCarouselItem itemId={3}>
                    <div className="h-100 w-100">
                        <img src={HomeBanner3} className='h-100 w-100' alt='...' id="banner" />
                    </div>
                </MDBCarouselItem>
            </MDBCarousel>
            <div
                className="mask position-absolute h-100 w-100"
                style={{ backgroundImage: "linear-gradient(to left, #00000080 ,#00000080 ,  #000000)", zIndex: 9999 }}
            >
                <MDBRow className="h-100 mx-0">
                    <MDBCol lg="6" className="h-100 px-0 d-flex flex-column justify-content-center align-items-center fade-up">
                        <h1 className="fw-bold text-light display-1" >Easy loans to </h1>
                        <h1 className="fw-bold text-light display-1">grow & succeed! </h1>
                    </MDBCol>
                </MDBRow>
            </div>
        </div>
    );
}